import { combineReducers } from 'redux'

import { reducer as data } from './State/data'
import { reducer as isFetching } from './State/isFetching'

export default combineReducers({
  data,
  isFetching,
})
